import React from "react";
import styles from "./Checkbox.css";
import Input from "./Input";

const Checkbox = function ({ children, ...props }) {
    return (
        <label className={styles.Checkbox}>
            <Input type="checkbox" {...props} />
            {children}
        </label>
    );
};

export default Checkbox;
